import { Message, MessageBox } from 'element-ui'

export default {
  install(Vue) {
    // 消息提示
    Vue.prototype.$modal = {
      // 成功消息
      msgSuccess(msg) {
        Message.success(msg)
      },
      // 错误消息
      msgError(msg) {
        Message.error(msg)
      },
      // 警告消息
      msgWarning(msg) {
        Message.warning(msg)
      },
      // 普通消息
      msgInfo(msg) {
        Message.info(msg)
      },
      // 确认框
      confirm(content, title = '系统提示') {
        return MessageBox.confirm(content, title, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      },
      // 提示框
      alert(content, title = '系统提示') {
        return MessageBox.alert(content, title, {
          confirmButtonText: '确定',
          type: 'warning'
        })
      }
    }
  }
}

